import { render, staticRenderFns } from "./MatterBudgetList.vue?vue&type=template&id=25c9820e&"
import script from "./MatterBudgetList.vue?vue&type=script&lang=js&"
export * from "./MatterBudgetList.vue?vue&type=script&lang=js&"
import style0 from "./MatterBudgetList.vue?vue&type=style&index=0&id=25c9820e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports